import { useMemo } from 'react';

import { LoadingLayout } from 'components';
import { config } from 'config';
import { lodash } from 'helpers';
import { useAccountDocuments } from 'hooks/account';
import { useTranslation } from 'libs/i18n';
import { OnboardingSuccessStatus } from 'modules/onboarding/common/components';

export const OnboardingSuccessStatusFeature = () => {
  const { t } = useTranslation();

  const { documents: accountDocuments, loading } = useAccountDocuments();

  const documents = useMemo(() => {
    const result: { id?: string; label: string; href?: string }[] =
      lodash.compact(
        accountDocuments.map((document) => ({
          id: document.id,
          label: t(`onboarding.fileTypeName.${document.type}`),
        }))
      );

    if (config.DOCUMENT_TEMPLATE_FOR_CLIENT_ORDERS_URL) {
      result.push({
        label: t(`onboarding-success-status.templateClientOrdersTitle`),
        href: config.DOCUMENT_TEMPLATE_FOR_CLIENT_ORDERS_URL,
      });
    }

    return result;
  }, [accountDocuments, t]);

  if (loading && !accountDocuments.length) {
    return <LoadingLayout />;
  }

  return <OnboardingSuccessStatus documents={documents} />;
};
